var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#252C32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14 13.2784C14 12.6929 14 12.4001 14.1221 12.2387C14.2284 12.0981 14.391 12.0111 14.567 12.0006C14.769 11.9886 15.0126 12.151 15.4997 12.4757L21.8397 16.7024C22.2422 16.9707 22.4435 17.1049 22.5136 17.274C22.575 17.4219 22.575 17.5881 22.5136 17.736C22.4435 17.9051 22.2422 18.0393 21.8397 18.3076L15.4997 22.5343C15.0126 22.859 14.769 23.0214 14.567 23.0094C14.391 22.9989 14.2284 22.9119 14.1221 22.7713C14 22.6099 14 22.3171 14 21.7316V13.2784Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.59a39d81ea8978463e20a5acde40277b.svg";
export { ForwardRef as ReactComponent };